<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-3">
        <BranchStatsPanel />
      </div>
      <!-- end col -->
      <div class="col-xl-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Privilege</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreatePrivilegeForm></CreatePrivilegeForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Create Privilege",
    meta: [{ name: "Create Privilege", content: window.__env.app.description }]
  },

  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreatePrivilege",
      title: "Create Privilege",
      items: [
        {
          text: "Privilege",
          href: "/"
        },
        {
          text: "Create Privilege",
          active: true
        }
      ]
    };
  }

};
</script>

<style scoped></style>
